import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, ExternalLink, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const MelhoresSitesSection = () => {
  const categorias = [
    {
      titulo: "Geradores de Tags e IA",
      descricao: "Sites de geração de tags e ferramentas de inteligência artificial",
      icone: "🤖",
      rota: "/melhores-sites",
      sites: ["RapidTags", "Abacus AI", "Golex AI", "DeepMind Veo"],
    },
    {
      titulo: "Plataformas de Vídeo",
      descricao: "Sites alternativos para hospedar e assistir vídeos",
      icone: "🎬",
      rota: "/bitchute",
      sites: ["BitChute", "Rumble", "PayChute"],
    },
    {
      titulo: "Criação de Vídeos",
      descricao: "Ferramentas para criar vídeos a partir de imagens",
      icone: "🎥",
      rota: "/videos",
      sites: ["OneImageVideo", "Vheer", "Canva"],
    },
    {
      titulo: "Lives e Vídeos",
      descricao: "Assista transmissões ao vivo e vídeos selecionados",
      icone: "📺",
      rota: "/melhores-sites?tab=lives",
      sites: ["Caminhando nos Trilhos", "Reflexão Diária", "Momento de Fé"],
    },
    {
      titulo: "MegaZone Downloads",
      descricao: "Os melhores sites da internet em um só lugar",
      icone: "💾",
      rota: "/melhores-sites?tab=outros",
      sites: ["Coletânea completa", "Links úteis", "Downloads diversos"],
    },
    {
      titulo: "Encurtador de Links",
      descricao: "Encurte links e ganhe dinheiro compartilhando",
      icone: "💰",
      rota: "/encurtador",
      sites: ["Encurta.net", "Ganhe com links"],
    },
  ];

  return (
    <section id="melhores-sites" className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Os Melhores Sites da Internet
          </h2>
          <p className="text-muted-foreground mt-2 max-w-2xl mx-auto">
            Uma coleção cuidadosamente selecionada dos melhores sites e ferramentas para diversos fins.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {categorias.map((categoria, index) => (
            <Card key={index} className="overflow-hidden border border-border h-full flex flex-col">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <span className="text-3xl">{categoria.icone}</span>
                  <CardTitle>{categoria.titulo}</CardTitle>
                </div>
                <CardDescription>{categoria.descricao}</CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <ul className="space-y-1">
                  {categoria.sites.map((site, siteIndex) => (
                    <li key={siteIndex} className="flex items-center gap-2">
                      <span className="w-1 h-1 bg-primary rounded-full"></span>
                      <span>{site}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
              <CardFooter>
                <Button asChild variant="outline" className="w-full">
                  <Link to={categoria.rota}>
                    Ver Mais <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground">
            <Link to="/melhores-sites">
              Ver Todos os Sites <ExternalLink className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-primary hover:bg-primary/10">
            <Link to="/melhores-sites-completo">
              Ver Versão Completa <ExternalLink className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MelhoresSitesSection;